import { Component, OnInit } from '@angular/core';
import { Recipient, SendMailModel } from '../../../../../models';
import { GenericEffectif } from '../../../../../models/effectif/genericEffectif.model';
import { ModeEffectif, Option, SelectionMode } from '../../../../../models/effectif/option.model';
import { StageService } from '../../services/stage-modal.service';
import { MailService } from '../mail.service'

@Component({
  selector: 'queoval-mail-step-one',
  templateUrl: './mail-one.component.html',
  styleUrls: ['./mail-one.component.css']
})
/*
* Composant pour la sélection des destinataires (Etape 1)
*/
export class MailOneComponent implements OnInit {

  //#region Constructeur
  constructor(
    public service: StageService,
    public mailService: MailService,
  ) { }
  //#endregion Constructeur

  //#region Cycle de vie
  ngOnInit(): void {
    this.updateSelectedList();

    this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL);
    this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURMAIL);
    this.OptionClient = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.CLIENTMAIL);
    this.OptionResponsables = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.ALLCONTACTRH);
    this.OptionPreinscrits = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.PREINSCRITS, "", SelectionMode.MULTIPLE);
  }
  //#endregion Cycle de vie

  //#endregion Variables globals
  /*liste envoyer au composant effectifs pour avoir les élèments cocher précédemment*/
  public lstEffectifsSelected: Array<string> = [];
  /* options pour init le composant effectif*/
  OptionStagiaire: Option;
  OptionFormateur: Option;
  OptionClient: Option;
  OptionResponsables: Option;
  OptionPreinscrits: Option;
  //#region Fonction Privates

  //#endregion Fonction Privates


  //#region Fonctions Publics

  /** remplit la liste des éléments sélectionnés pour cocher la checkbox */
  public updateSelectedList() {
    this.lstEffectifsSelected = [];
    this.mailService.modelMail.RecipientList.forEach(x => this.lstEffectifsSelected.push(x.Ident));
  }
  /**
   * remplis la liste des destinataires avec les contacts/clients cocher 
   * @param data effectifs sélectionnés
   */
  public UpdateListEffectif(data: Array<GenericEffectif>) {
    //cas ou on séléctionne l'effectif
    if (data.length > 0) {

      data.forEach(Effectif => {
        if (Effectif.IsSelected) {

          //verifie si l'effectif existe dans la liste
          let EffecExistInList: boolean = false;
          for (var i = 0; i < this.mailService.modelMail.RecipientList.length; i++) {
            if (this.mailService.modelMail.RecipientList[i].Ident == Effectif.Id) {
              EffecExistInList = true;
              break;
            }
          }
          //si l'effectif n'existe pas dans la liste
          if (!EffecExistInList) {
            const newRecipient = new Recipient();
            newRecipient.Ident = Effectif.Id;
            newRecipient.Value = Effectif.Text;
            switch (Effectif.Type.replace(" ", "").toUpperCase()) {
              case "CLIENTS":
                newRecipient.TypeRecipient = "CLIENT";
                break;
              case "APPRENANTS":
              case "FORMATEURS":
              case "RESPONSABLERH":
              case "PRÉINSCRITS":
                newRecipient.TypeRecipient = "CONTACT";
                break;
              default:
                newRecipient.TypeRecipient = "CONTACT";
                break;
            }

            this.mailService.modelMail.RecipientList.push(newRecipient);
            this.updateSelectedList();
          }
        } else {

          this.mailService.modelMail.RecipientList.forEach(recip => {
            if (Effectif.Id == recip.Ident && !Effectif.IsSelected) {
              this.mailService.modelMail.RecipientList.splice(this.mailService.modelMail.RecipientList.indexOf(recip), 1);
              this.updateSelectedList();
            }
          })
        }
      });
    }
    this.mailService.VerifyIfListDestIsEmpty();
    this.mailService.lstDocumentsSelected = [];
    this.mailService.modelMail.ListDocAffected = [];
    //this.mailService.modelMail = new SendMailModel();
  }
  //#endregion Fonctions Publics
}
